import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { Group } from "../../lib/types";
import GroupCard from "./GroupCard";

interface GroupsListProps {
  groups: Group[];
}

const GroupsList: React.FC<GroupsListProps> = ({ groups }) => {
  if (!groups.length) {
    return (
      <Stack alignItems="center" spacing={1} sx={{ py: 6 }}>
        <Typography variant="h6">No groups yet</Typography>
        <Typography color="text.secondary">
          Create your first group to share data.
        </Typography>
      </Stack>
    );
  }

  return (
    <Grid container spacing={3}>
      {groups.map((group) => (
        <Grid size={{ xs: 12, md: 6, lg: 4 }} key={group.id}>
          <GroupCard group={group} />
        </Grid>
      ))}
    </Grid>
  );
};

export default GroupsList;
